import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-item-pregunta',
  templateUrl: './item-pregunta.component.html',
  styleUrls: ['./item-pregunta.component.scss']
})
export class ItemPreguntaComponent {
  @Input() pregunta: string = "";
  @Output("evento_click") evento_click: EventEmitter<any> = new EventEmitter<any>();

  ejecutarFuncion() {
    this.evento_click.emit();
  }
}
